import React, {Component} from 'react'
import PropTypes from "prop-types";

class FormElementContainerWithoutTitle extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        let {title,Component,rest,isSub} = this.props
        return (
            <div>
                <Component {...rest} />
            </div>

        )
    }
}

FormElementContainerWithoutTitle.propTypes = {
    Component: PropTypes.elementType.isRequired,
    rest: PropTypes.object
};

export default FormElementContainerWithoutTitle;
